module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/leisure-report/leisure-report.component.css
// module id = ./src/app/leisure-report/leisure-report.component.css
// module chunks = main